// eslint-disable

const routes = [

  // Full Page Layout
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/pages/LoginPage/Index.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout'),
    redirect: { name: 'ManageShopsPage' },
    children: [
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        meta: { auth: true },
        props: {
          pageTitle: 'Mon profil',
        },
      },
      {
        path: '/profil-utilisateur',
        name: 'UserProfile',
        component: () => import('@/views/pages/ProfilePage/ProfilePage.vue'),
        props: (route) => ({
          userId: route.query.id,
          pageTitle: 'Profil utilisateur',
        }),
        meta: { auth: true },
      },
      {
        path: '/magasins',
        name: 'ManageShopsPage',
        component: () => import('@/views/pages/ManageShopsPage/Index.vue'),
        props: true,
        meta: {
          auth: true,
        },
      },
      {
        path: '/magasin/:shopId',
        name: 'ShopPage',
        component: () => import('@/views/pages/ShopPage/Index.vue'),
        props: (route) => ({
          shopId: route.params.shopId,
          shopType: route.query.shopType,
        }),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    name: 'Home',
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
